import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "row justify-left q-py-none",
  style: { minHeight: '25px' }
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  tabindex: "0",
  ref: "address_menu",
  style: {"max-height":"50vh","min-height":"50vh","min-width":"200px","max-width":"500px","overflow-x":"hidden","overflow-y":"auto","padding":"0 6px"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "q-mx-auto q-px-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_simple_element = _resolveComponent("simple-element")!
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.container, (field, level) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row justify-left q-py-none q-my-none no-wrap items-center",
          key: 'adr_'+level
        }, [
          _createVNode(_component_q_input, {
            ref_for: true,
            ref: (el) => { _ctx.inputs[level] = el },
            class: _normalizeClass([
						(_ctx.larger ? 'thin-input-noborder-larger' : 'thin-input-noborder'),
						{ 'err-mode-field': _ctx.useRequired && field.Required && !field.Value }
					]),
            borderless: "",
            debounce: "500",
            "no-error-icon": "",
            "input-style": `width: ${(field.Value ? field.Value.length : field.Placeholder.length)*(_ctx.larger ? 8.5 : 7.5)}px;`,
            modelValue: field.Value,
            "onUpdate:modelValue": [($event: any) => ((field.Value) = $event), _ctx.modelUpdate],
            placeholder: field.Placeholder,
            onClick: _ctx.fillChains,
            onFocus: ($event: any) => (_ctx.onFieldFocus(level)),
            onBlur: ($event: any) => (_ctx.onFieldBlur(level)),
            onKeydown: [
              _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowDown(1)), ["exact","prevent"]), ["down"])),
              _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowDown(3)), ["shift","exact","prevent"]), ["down"])),
              _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowUp(1)), ["exact","prevent"]), ["up"])),
              _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowUp(3)), ["shift","exact","prevent"]), ["up"])),
              _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.selectElement(_ctx.index_selected)), ["prevent"]), ["enter"])),
              _withKeys(($event: any) => (_ctx.focusPrev($event, level)), ["left"]),
              _withKeys(($event: any) => (_ctx.focusPrev($event, level)), ["backspace"]),
              _withKeys(($event: any) => (_ctx.focusNext($event, level)), ["right"]),
              _cache[5] || (_cache[5] = _withKeys(($event: any) => {_ctx.hintOpen = false; _ctx.isEditing = false;}, ["esc"]))
            ]
          }, null, 8, ["class", "input-style", "modelValue", "onUpdate:modelValue", "placeholder", "onClick", "onFocus", "onBlur", "onKeydown"]),
          (level < _ctx.container.length-1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, ", "))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.isEditing && _ctx.showClear)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            padding: "xs",
            flat: "",
            dense: "",
            color: "grey-7",
            icon: _ctx.checkIcon,
            size: "sm",
            onClick: _withModifiers(_ctx.saveAddressModel, ["stop","prevent"])
          }, null, 8, ["icon", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isEditing && _ctx.showClear)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            padding: "xs",
            flat: "",
            dense: "",
            color: "grey-7",
            icon: "arrow_back",
            size: "sm",
            onClick: _withModifiers(_ctx.clearAddressModel, ["stop","prevent"])
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.showDelete)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 2,
            padding: "xs",
            flat: "",
            dense: "",
            "aria-label": _ctx.$t('delete_filter'),
            icon: "close",
            size: "sm",
            tabindex: "-1",
            color: "grey-8",
            onClick: _withModifiers(_ctx.emitDelete, ["stop","prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, {
                delay: 300,
                anchor: "top middle",
                self: "center middle"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.isEditing || !_ctx.container.filter(a => a.Value).length]
    ]),
    _createElementVNode("div", {
      class: "row",
      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop","prevent"])),
      onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop","prevent"])),
      onMouseup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isEditing = true))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.container.filter(a => a.Value), (span, sp_i) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: sp_i,
          style: _normalizeStyle({ fontSize: _ctx.larger ? '14px' : '13px' }),
          class: "no-wrap flex items-center"
        }, _toDisplayString(span.Value + (sp_i === _ctx.container.filter(a => a.Value).length - 1 ? '' : `, `)), 5)), [
          [_vShow, !_ctx.isEditing]
        ])
      }), 128)),
      (!_ctx.isEditing && _ctx.container.filter(a => a.Value).length)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            style: { marginLeft: '4px' },
            padding: "xs",
            flat: "",
            dense: "",
            color: "grey-7",
            icon: _ctx.squareEditIcon,
            size: "sm"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      (_ctx.showDelete && !_ctx.isEditing && _ctx.container.filter(a => a.Value).length)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            padding: "xs",
            flat: "",
            dense: "",
            "aria-label": _ctx.$t('delete_filter'),
            icon: "close",
            size: "sm",
            tabindex: "-1",
            color: "grey-8",
            onClick: _ctx.emitDelete
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, {
                delay: 300,
                anchor: "top middle",
                self: "center middle"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true)
    ], 32),
    _createVNode(_component_q_menu, {
      modelValue: _ctx.hintOpen,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.hintOpen) = $event)),
      "no-parent-event": "",
      "no-focus": "",
      style: {"overflow-x":"hidden"}
    }, {
      default: _withCtx(() => [
        (_ctx.options && _ctx.options.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (el, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'varlst_'+index,
                  ref_for: true,
                  ref: (el) => { _ctx.divs[index] = el },
                  class: _normalizeClass(['q-py-none var-lst-item', { 'var-lst-subselection': _ctx.index_selected === index }]),
                  onClick: ($event: any) => (_ctx.selectElement(index))
                }, [
                  _createVNode(_component_simple_element, {
                    element: { Id: el.Id, Name: el.DisplayName },
                    elementType: 1,
                    filter_string: this.container[_ctx.currentLevel]?.Value
                  }, null, 8, ["element", "filter_string"])
                ], 10, _hoisted_4))
              }), 128))
            ], 512))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('no_elements_found')) + " " + _toDisplayString(_ctx.$t('no_items_found')), 1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}